import React, {useEffect, useState} from 'react'
import Contact from './Contact';
import styled from '@emotion/styled'


const Button = styled.button`
    display:flex;
    flex-direction:row;
    padding: 0.16rem 5.375rem;
    height:2.25rem;
    font-size: var(--font-14);
    white-space:nowrap;
    color: var(--color-white);
    
    max-width:5rem;
    background: ${props => props.variantColor ? props.variantColor : 'gray'};
    box-shadow: ${props => props.variantShadow ? props.variantShadow : 'none'};
    border-radius: 44px;
    @media only screen and (max-width: 425px) {
        
        /* margin-left: 5.2rem; */
    }
`;

const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    .contact-form{
        display:flex;
        flex-direction:column;
    }
    @media only screen and (max-width: 768px) {
        padding-left: 0rem;
    }
    @media only screen and (max-width: 425px) {
     
    }
`;

const Card = styled.div`
    display: flex;
    flex-direction:column;
    align-items: center;
    height: fit-content;
    box-shadow: ${props => props.CardShadow ? props.CardShadow : 'var(--card-shadow-large)'};
    padding: var(--space-40) var(--space-64) var(--space-48);
    border-radius: var(--space-24);
    background-color: ${props => props.CardColor ? props.CardColor : 'var(--color-white)'};

    @media only screen and (max-width: 768px) {
        align-self:center;
        margin-bottom:5rem
    }
    @media only screen and (max-width: 425px) {
        box-shadow:none;
        border-radius:0rem;
        align-items:center;
        margin-bottom:5rem
    }
    @media only screen and (max-width: 320px) {
        width:11.25rem;
        margin-bottom:5rem
    }
`;

const CardHeader = styled.h2`
    margin-bottom:3rem;
    line-height: 3.25rem;
    width:25rem;
    
    font-size: var(--font-32);
    font-weight: 500;
    color: var(--company-dark);

    @media only screen and (max-width: 425px) {
        font-size:var(--font-24);
        
    }
`;

const CardText = styled.p`
    position:relative;
    font-family: Inter,sans-serif;
    font-style: normal;
    font-weight: normal;
    font-size: var(--font-16);
    line-height: var(--space-24);
    bottom:3rem;
    
    color:var(--color-gray-700);
    @media only screen and (max-width: 425px) {
        /* width:22rem; */
    }
`;
const CardTopLayout = styled.div`
    display:flex;
    flex-direction:column;
    width:fit-content;
    white-space:normal;
    @media only screen and (max-width: 500px) {
        width: 90vw;
    }
    @media only screen and (max-width: 425px) {
        /* margin-left: 5rem; */
    }
`;
const CardInput = styled.input`
    text-indent:1rem;
    background: #F6F8F8;
    height: var(--space-48);
    width: 28.685rem;
    border: 1px solid #D3D9DE;
    box-sizing: border-box;
    align-self:center;
    border-radius: var(--space-12);
    margin-top: var(--space-2);
    margin-bottom: var(--space-20);
    @media only screen and (max-width: 425px) {
        width: 90vw;
    }
    
`;

const CardMessage = styled.textarea`
    resize:none;
    font-family: Inter,sans-serif;
    padding-top:var(--space-12);
    text-indent:1rem;
    background: #F6F8F8;
    width: 28.685rem;
    height: 10rem;
    border: 1px solid #D3D9DE;
    box-sizing: border-box;
    align-self:center;
    border-radius: var(--space-12);
    margin-top: var(--space-2);
    margin-bottom: var(--space-20);
    @media only screen and (max-width: 425px) {
        width: 90vw;
    }
`;



function Form(props) {
  const [name,setName] = useState('');
  const [email,setEmail] = useState('');
  const [message,setMessage] = useState('');

  
        return (
          
            <Card CardColor={props.cardColor} CardShadow={props.cardColor}>
                
                <CardContainer>
                    <CardTopLayout>
                        <CardHeader>{props.title}</CardHeader>
                        <CardText>{props.sub}</CardText>
                    </CardTopLayout>
                    <form className="contact-form">
                    {props.btntext === "Leave Feedback" ? null : <CardInput placeholder="Your Name"  onChange={(e)=>setName(e.target.value.trim())}/>}
                    <CardInput placeholder="Your Email"  onChange={(e)=>setEmail(e.target.value.trim())}/>
                    <CardMessage placeholder="Type your message here" onChange={(e)=>setMessage(e.target.value.trim())}/>
                    <Button variantColor={props.color} variantShadow={props.shadow}
                    onClick={(e)=>{e.preventDefault();props.btntext === "Send" ? props.contact(name,email,message,"contact_me"):props.contact("",email,message,"feedback");
                        }}>{props.btntext}</Button>
                </form>
                </CardContainer>
                
            </Card>
           
        )
    
}

export default Form
